import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setRoll } from "../redux/index";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "Calendars/Components/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import SomuraSelectField from "Components/SomuraSelectField";

const mapStateToProps = (state) => {
  return {
    loggedUser: state.loggeduser.LoggedUser,
    rolls: state.security.Rolls,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRoll: (values) => dispatch(setRoll(values)),
  };
};

const RollChangeDialog = ({ onClose, loggedUser, rolls, setRoll }) => {
  const [state, setState] = useState({ roll: "" });

  const rollOptions = rolls?.map((R) => ({
    label: R.rollName,
    value: R.id,
  }));

  const handleRollChange = (event) => {
    setState({ roll: event.target.value });
    setRoll({ rollId: event.target.value, userId: loggedUser.id });
    setTimeout(() => {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
      localStorage.setItem("lastPage", 'Dashboard');
      window.location.reload(true);
    }, "500");
    onClose();
  };

    useEffect(() => {
      if (
        Object.keys(loggedUser).length > 0 &&
        Object.keys(rolls).length > 0
      ) {
        setState({ roll: loggedUser.rollId });
      }
      //eslint-disable-next-line
    },[rolls])

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "98%",
            maxWidth: "20rem",
          },
        },
      }}
      open={true}
      onKeyUp={(e) => {
        if (e.key === "Escape") {
          onClose();
        }
      }}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      disableEscapeKeyDown={true}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle
        sx={{
          width: "20rem",
          padding: "4px 10px",
          fontWeight: "200",
          color: "text.screenTitle",
        }}
        noMoveIcon
        dialogTitle={"Change Roll"}
        closeForm={onClose}
      />
      <DialogContent
        sx={{
          backgroundColor: "background.scrollBarThumb",
        }}
      >
        <SomuraSelectField
          name="roll"
          label={"Roll"}
          value={state.roll}
          variant="outlined"
          size="small"
          fullWidth
          maxheight={"20rem"}
          options={rollOptions}
          onChange={handleRollChange}
        />
      </DialogContent>
    </Dialog>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RollChangeDialog);
